//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var EZUIKit;
var ms_ie = false;
var ua = window.navigator.userAgent.toLowerCase();
// console.log(ua);
// alert(ua)
var old_ie = ua.indexOf("MSIE");
var new_ie = ua.indexOf("trident/");
var is360 = false;
var append = document.getElementById("append");
if (old_ie > -1 || new_ie > -1) {
  // alert(old_ie,new_ie)
  // alert(6)
  EZUIKit = false;
  ms_ie = true;
}
if (window.navigator.appName.indexOf("Microsoft") != -1) {
  //alert(5)
  me_ie = true;
}
// if (window.navigator.userAgent.indexOf("Chrome/63") != -1) {
//   EZUIKit = false;
// }
if (window.navigator.mimeTypes[40] || !window.navigator.mimeTypes.length) {
  // alert(4)
  EZUIKit = false;
  is360 = true;
}

if (ms_ie) {
  // alert(3)
  EZUIKit = false;
  var DEFAULT_VERSION = 8.0;
  var ua = navigator.userAgent.toLowerCase();
  var isIE = ua.indexOf("msie") > -1;
  var safariVersion;
  if (isIE) {
    // alert(2)
    safariVersion = ua.match(/msie ([d.]+)/)[1];
  }
  if (safariVersion <= DEFAULT_VERSION) {
    //alert(1)
    EZUIKit = false;
    console.log(
      "系统检测到您正在使用ie8以下内核的浏览器，不能实现完美体验，请更换或升级浏览器访问！"
    );
  }
}
if (EZUIKit != false) {
  EZUIKit = require("@/utils/ezuikit.js");
}

//import EZUIKit from "ezuikit-js";
import Swiper from "./js/swiper.min.js";
import "./css/swiper.css";

export default {
  data() {
    return {
      urls: [],
      srcImg: "",
      EZUIKit: EZUIKit,
      currentPage: 1,
      pageSize: 10,
      swiperList: [],
      soilData: {},
      EnvData: {},
      videoUrl: "",
      hkToken: "",
      decoderPath: "",
      deviceName: "",
      deviceTypeId: "",
      deviceCode: "",
      deviceName: "",
      deviceTypeName: "",
      showSwiper: false,
      deviceStatus: "设备加载中",
      yesDate: "",
      growSubmitObj: {},
      systemTime: "",
      nowTime: "",
      timer: null,
      deviceFlag: 2,
      srcList: [],
      edition: "",
      soilV4temData: "",
      soilV4humData: "",
      soilV4SaltData: "",
      soilV4ConData: "",
      envV4Temperature: "",
      envV4Humidity: "",
      envV4WindDirection: "",
      envV4WindSpeed: "",
      envV4Pressure: "",
      envV4Light: "",
    };
  },
  props: ["farmAllData"],
  watch: {
    farmAllData() {
      this.initDeviceMsg();
    },
  },
  mounted() {
    this.initDeviceMsg();
  },
  beforeDestroy() {
    if (this.player != null) {
      this.player.stop();
      this.player = null;
    }

    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    // 获取年月日
    convertToDate(date) {
      var date = new Date(date);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      m = m < 10 ? "0" + m : m;
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    },
    // 获取时分
    converTimeDate(date) {
      var date = new Date(date);
      var h = date.getHours();
      var s = date.getMinutes();
      h = h < 10 ? "0" + h : h;
      s = s < 10 ? "0" + s : s;
      return h + ":" + s;
    },
    initDeviceMsg() {
      console.log(this.farmAllData.deviceTypeId);
      this.deviceTypeId = this.farmAllData.deviceTypeId;
      this.deviceTypeName = this.farmAllData.deviceTypeName;
      this.deviceCode = this.farmAllData.deviceCode;
      this.deviceName = this.farmAllData.deviceName;
      this.edition = this.farmAllData.edition;
      if (this.deviceTypeId == 10) {
        this.EnvData = {
          temperature: "",
          humidity: "",
          windDirection: "",
          windSpeed: "",
          pressure: "",
          light: "",
        };
        this.getEnvData();
      } else if (this.deviceTypeId == 20) {
        this.getSoilData();
      } else if (this.deviceTypeId == 30) {
        // 默认进来剩余时间段调历史接口
        this.systemTime = this.convertToDate(new Date());
        let qDay = new Date(
          new Date(this.systemTime).getTime() - 24 * 60 * 60 * 1000
        ); //计算当前日期 -1
        this.yesDate = this.convertToDate(qDay);
        this.nowTime = this.converTimeDate(new Date());
        if (
          (this.nowTime >= "00:00" && this.nowTime <= "07:00") ||
          (this.nowTime >= "19:00" && this.nowTime <= "24:00")
        ) {
          this.deviceStatus = "夜间监测休眠";
        } else {
          this.getHisDevData();
        }

        // 添加定时器
        this.timer = setInterval(() => {
          // 获取当天日期
          this.systemTime = this.convertToDate(new Date());
          // 获取当天时分
          this.nowTime = this.converTimeDate(new Date());
          // 获取昨天日期
          let beforeDay = new Date(
            new Date(this.systemTime).getTime() - 24 * 60 * 60 * 1000
          ); //计算当前日期 -1
          this.yesDate = this.convertToDate(beforeDay); //格式化日期并赋值
          // 19:00-07:00 夜间监测休眠模式
          if (
            (this.nowTime >= "00:00" && this.nowTime <= "07:00") ||
            (this.nowTime >= "19:00" && this.nowTime <= "24:00")
          ) {
            this.deviceStatus = "夜间监测休眠";
          } else {
            if (this.deviceFlag == 1) {
              if (
                (this.nowTime >= "09:00" && this.nowTime <= "09:10") ||
                (this.nowTime >= "10:00" && this.nowTime <= "10:10") ||
                (this.nowTime >= "11:00" && this.nowTime <= "11:10") ||
                (this.nowTime >= "12:00" && this.nowTime <= "12:10") ||
                (this.nowTime >= "13:00" && this.nowTime <= "13:10") ||
                (this.nowTime >= "14:00" && this.nowTime <= "14:10") ||
                (this.nowTime >= "15:00" && this.nowTime <= "15:10") ||
                (this.nowTime >= "16:00" && this.nowTime <= "16:10")
              ) {
                this.deviceStatus = "长势正在拍照中";
              } else {
                this.deviceStatus = "设备正常";
              }
            } else if (this.deviceFlag == 0) {
              this.deviceStatus = "设备异常";
            }
          }
        }, 1000);
        // 调当天长势接口
        this.getPicLately();
        // this.getGrowData();
      } else if (this.deviceTypeId == 40) {
        document.getElementById("playVideo").innerHTML = "";
        if (this.EZUIKit) {
          this.getVideoUrl();
        }
        //  else {
        //   this.$message({
        //     message:
        //       "该浏览器对于视频监控不能实现完美体验，请更换或升级浏览器访问！",
        //     type: "error",
        //     customClass: "customClass",
        //   });
        // }
      }
      this.$nextTick(() => {
        if (this.player != null) {
          this.player.stop();
          this.player = null;
        }
      });
    },

    // 历史设备去状态接口
    getHisDevData() {
      var obj = {
        deviceCode: this.deviceCode,
        type: 3, //自定义时间段
        startTime: this.yesDate,
        endTime: this.systemTime,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      };
      this.$http.nqMonitor.monitorGrow(obj).then((res) => {
        if (res.data.content.length > 0) {
          this.deviceFlag = 1;
        } else {
          this.deviceFlag = 0;
        }
      });
    },
    // 土壤监测
    getSoilData() {
      if (this.edition != 4) {
        this.$http.nqMonitor
          .monitorSoil({ sensorNum: this.deviceCode })
          .then((res) => {
            console.log(res);
            if (res.status == 1) {
              this.soilData = res.data;

              this.deviceStatus = res.data.deviceState;
            } else {
              this.deviceStatus = null;
            }
          });
      } else {
        this.$http.nqMonitor
          .monitorGroupV4({ imei: this.deviceCode })
          .then((res) => {
            if (res.status == 1) {
              if (res.data.result && res.data.result.length > 0) {
                let soilV4DataList = res.data.result;
                var that = this;
                soilV4DataList.forEach((val) => {
                  // B1土壤温度
                  if (val.sensorType && val.sensorType == "B1") {
                    that.soilV4temData = val.sensorData;
                  }
                  // B2土壤湿度
                  if (val.sensorType && val.sensorType == "B2") {
                    that.soilV4humData = val.sensorData;
                  }
                  // B3土壤盐分
                  if (val.sensorType && val.sensorType == "B3") {
                    that.soilV4SaltData = val.sensorData;
                  }
                  // B4土壤电导率
                  if (val.sensorType && val.sensorType == "B4") {
                    that.soilV4ConData = val.sensorData;
                  }
                });

                let A = new Date(res.data.result[0].sendTime);
                let U = A.getTime();
                let V = new Date(new Date() - 1000 * 60 * 60 * 24 * 30); //三十天前的时间戳
                console.log(U);
                if (U < V) {
                  this.deviceStatus = "设备异常";
                } else {
                  this.deviceStatus = "设备正常";
                }
              } else {
                this.soilV4temData = "";
                this.soilV4humData = "";
                this.soilV4SaltData = "";
                this.soilV4ConData = "";
                this.deviceStatus = null;
              }
            } else {
              this.deviceStatus = null;
            }
          });
      }
    },
    // 环境实时
    getEnvData() {
      if (this.edition != 4) {
        this.$http.nqMonitor
          .monitorEnv({ sensorNum: this.deviceCode })
          .then((res) => {
            if (res.status == 1) {
              this.EnvData = {
                temperature: "",
                humidity: "",
                windDirection: "",
                windSpeed: "",
                pressure: "",
                light: "",
              };

              if (res.data && res.data != null) {
                var windDirection = "";
                if (res.data.windDirection && res.data.windDirection != null) {
                  if (res.data.windDirection == "W") {
                    windDirection = "西";
                  } else if (res.data.windDirection == "N") {
                    windDirection = "北";
                  } else if (res.data.windDirection == "E") {
                    windDirection = "东";
                  } else if (res.data.windDirection == "ES") {
                    windDirection = "东南";
                  } else if (res.data.windDirection == "WS") {
                    windDirection = "西南";
                  } else if (res.data.windDirection == "WN") {
                    windDirection = "西北";
                  } else if (res.data.windDirection == "S") {
                    windDirection = "南";
                  } else if (res.data.windDirection == "EN") {
                    windDirection = "东北";
                  }
                }
                this.EnvData = {
                  temperature:
                    res.data.temperature != null
                      ? res.data.temperature + "℃"
                      : "—",
                  humidity:
                    res.data.humidity != null ? res.data.humidity + "%" : "—",
                  pressure: res.data.humidity != null ? 0 + "kpa" : "—",
                  windDirection:
                    windDirection != "" ? windDirection + "风" : "—",
                  windSpeed:
                    res.data.windSpeed != null
                      ? res.data.windSpeed + "km/h"
                      : "—",
                  light: res.data.light != null ? res.data.light + "lux" : "—",
                };
                this.deviceStatus = res.data.deviceState;
              } else {
                this.deviceStatus = null;
              }
            } else {
              this.deviceStatus = null;
            }
          });
      } else {
        this.$http.nqMonitor
          .monitorGroupV4({ imei: this.deviceCode })
          .then((res) => {
            if (res.status == 1) {
              console.log(res.data.result);
              if (res.data.result && res.data.result.length > 0) {
                let envV4DataList = res.data.result;
                var that = this;
                envV4DataList.forEach((val) => {
                  // A0空气温度
                  if (val.sensorType && val.sensorType == "A0") {
                    that.envV4Temperature = val.sensorData;
                  }
                  // A1空气湿度
                  if (val.sensorType && val.sensorType == "A1") {
                    that.envV4Humidity = val.sensorData;
                  }
                  // A5大气压力
                  if (val.sensorType && val.sensorType == "A5") {
                    that.envV4Pressure = val.sensorData;
                  }
                  // A3风速
                  if (val.sensorType && val.sensorType == "A3") {
                    that.envV4WindSpeed = val.sensorData;
                  }
                  // A4风向
                  if (val.sensorType && val.sensorType == "A4") {
                    if (val.sensorData && val.sensorData != null) {
                      if (val.sensorData == "W") {
                        that.envV4WindDirection = "西";
                      } else if (val.sensorData == "N") {
                        that.envV4WindDirection = "北";
                      } else if (val.sensorData == "E") {
                        that.envV4WindDirection = "东";
                      } else if (val.sensorData == "ES") {
                        that.envV4WindDirection = "东南";
                      } else if (val.sensorData == "WS") {
                        that.envV4WindDirection = "西南";
                      } else if (val.sensorData == "WN") {
                        that.envV4WindDirection = "西北";
                      } else if (val.sensorData == "S") {
                        that.envV4WindDirection = "南";
                      } else if (val.sensorData == "EN") {
                        that.envV4WindDirection = "东北";
                      }
                    }
                  }
                  // A2光照强度
                  if (val.sensorType && val.sensorType == "A2") {
                    that.envV4Light = val.sensorData;
                  }
                });
                let A = new Date(res.data.result[0].sendTime);
                let U = A.getTime();
                let V = new Date(new Date() - 1000 * 60 * 60 * 24 * 30); //三十天前的时间戳
                console.log(U);
                if (U < V) {
                  this.deviceStatus = "设备异常";
                } else {
                  this.deviceStatus = "设备正常";
                }
              } else {
                this.envV4Temperature = "";
                this.envV4Humidity = "";
                this.envV4WindDirection = "";
                this.envV4WindSpeed = "";
                this.envV4Pressure = "";
                this.envV4Light = "";
                this.deviceStatus = null;
              }
            } else {
              this.deviceStatus = null;
            }
          });
      }
    },
    // 长势数据
    // getGrowData() {
    //   this.$http.nqMonitor
    //     .monitorGrow({
    //       deviceCode: this.deviceCode,
    //       type: 3, //自定义时间段
    //       startTime: this.systemTime,
    //       endTime: this.systemTime,
    //       currentPage: this.currentPage,
    //       pageSize: this.pageSize,
    //     })
    //     .then((res) => {
    //       if (res.data.content.length > 0) {
    //         this.showSwiper = true;
    //         this.swiperList = res.data.content;
    //         this.$nextTick(() => {
    //           this.swiperFun();
    //         });
    //       } else {
    //         this.showSwiper = false;
    //         this.swiperList = [];
    //       }
    //     });
    // },
    // 长势图片最近三张
    getPicLately() {
      let obj = {
        deviceCode: this.deviceCode,
        num: 3, //最近条数，默认3条
      };
      this.$http.nqMonitor.picLately(obj).then((res) => {
        // console.log(res);
        if (res.status === "1") {
          this.urls = res.data;
          this.srcList = [];
          this.showSwiper = true;
          this.urls.forEach((item, index) => {
            this.srcList.push(item.imgeUrl);
          });
        } else {
          this.showSwiper = false;
          this.srcList = [];
          this.$message({
            message: res.errMsg,
            type: "error",
            customClass: "customClass",
          });
        }
      });
    },
    // 长势
    swiperFun() {
      var that = this;
      var galleryThumbs = new Swiper(".gallery-thumbs", {
        spaceBetween: 8,
        slidesPerView: "auto",
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      });
      var galleryTop = new Swiper(".gallery-top", {
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: galleryThumbs,
        },
        on: {
          click: function () {
            if (this.clickedIndex != undefined) {
              that.srcImg = this.clickedSlide.firstChild.currentSrc;
            }
          },
        },
      });
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp * 1); //这个是10位数字的转换 如果想要13位数的话需要乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        date.getHours() < 10
          ? "0" + date.getHours() + ":"
          : date.getHours() + ":";
      var m =
        date.getMinutes() < 10
          ? "0" + date.getMinutes() + ":"
          : date.getMinutes() + ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    // 获取视频地址
    getVideoUrl() {
      let submitData = {
        deviceSerial: this.deviceCode,
        quality: 1,
      };
      this.$http.nqMonitor.videoPlayAddress(submitData).then((res) => {
        this.deviceStatus = "设备加载中";
        if (res.data.code == 200) {
          this.videoUrl = res.data.data.url;
          this.hkToken = res.data.hkystoken;
          this.deviceStatus = "设备正常";

          this.$nextTick(() => {
            this.playVideo();
          });
        } else if (res.data.code == 20014) {
          this.deviceStatus = "设备不存在";
          this.$message({
            message: "设备不存在",
            type: "error",
            customClass: "customClass",
          });
        } else if (res.data.code == 20007) {
          this.deviceStatus = "设备不在线";
          this.$message({
            message: "设备不在线",
            type: "error",
            customClass: "customClass",
          });
        } else if (res.data.code == 20018) {
          this.deviceStatus = "设备异常";
          this.$message({
            message: "设备异常，请联系管理员",
            type: "error",
            customClass: "customClass",
          });
        } else {
          this.deviceStatus = "设备不在线";
          this.$message({
            message: "设备不在线",
            type: "error",
            customClass: "customClass",
          });
        }
      });
    },
    playVideo() {
      this.player = new EZUIKit.EZUIKitPlayer({
        id: "playVideo",
        url: this.videoUrl,
        autoplay: true,
        accessToken: this.hkToken,
        decoderPath: this.decoderPath,
        width: 265,
        height: 150,
      });
    },

    isFullScreen() {
      this.player.fullScreen();
    },
    ptzControl(direction) {
      this.toControl(direction, 1);
    },
    //控制云台
    toControl(direction, speed) {
      var sta = false;
      if (-1 == direction) {
        this.isTurn = false;
        direction = 2;
        sta = true; //镜头一直转
      }
      if (direction == 111) {
        direction = 2;
        this.isTurn = true;
        this.closeControl();
      }
      let submitData = {
        deviceSerial: this.deviceCode,
        channelNo: 1,
        direction: direction,
        speed: speed,
      };
      this.$http.nqMonitor.videoControl(submitData).then((res) => {
        if (res.data.status == 1) {
          if (!sta) {
            this.closeControl();
          }
        }
      });
    },
    //停止云台控制
    closeControl() {
      let submitData = {
        deviceSerial: this.deviceCode,
        channelNo: 1,
      };
      this.$http.nqMonitor.stopControl(submitData).then((res) => {
        if (res.data.status == 1) {
        } else {
          this.$message({
            message: res.data.errMsg,
            type: "error",
            customClass: "customClass",
          });
        }
      });
    },
    // 查看历史数据
    checkHistory(val) {
      sessionStorage.setItem("deviceCode", this.deviceCode);
      sessionStorage.setItem("deviceName", this.deviceName);
      if (val == 1) {
        this.$router.push("/Agricultural/AgriculturalMonitoring/Soil");
      } else if (val == 2) {
        this.$router.push("/Agricultural/AgriculturalMonitoring/Weather");
      } else if (val == 3) {
        this.$router.push("/Agricultural/AgriculturalMonitoring/Vigour");
      } else if (val == 4) {
        if (this.player != null) {
          this.player.stop();
          this.player = null;
        }
        this.$emit("videoChange", true);
      }
    },
  },
};
